module.exports = __webpack_public_path__ + "d2f94abcc6241f2a1501378e9fae6087.pdf";